globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Social = appCustomerSpace.Modals.Social || {};

appCustomerSpace.Modals.Social.DisconnectPlatform = (function(superClass) {

  utils.extend(DisconnectPlatform, superClass);

  function DisconnectPlatform() {
    return DisconnectPlatform.__super__.constructor.apply(this, arguments);
  }

  $.extend(DisconnectPlatform.prototype, {
    init: function() {
      return DisconnectPlatform.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data, successMsg) {
      if (data.response) {
        window.location.reload();
      }
    },
  });

  return DisconnectPlatform;

})(appCustomerSpace.Modal);
